/**
 * Back in Stock - Toggle visibility and update variant info
 * Uses the theme's pub/sub system to listen for variant changes
 */

(function() {
  function findBackInStockWrapper(sectionId) {
    const section = document.getElementById('shopify-section-' + sectionId) ||
                    document.querySelector('[data-section-id="' + sectionId + '"]');
    if (section) {
      return section.querySelector('[id^="BackInStock-"]');
    }
    return document.querySelector('[id^="BackInStock-"]');
  }

  function handleVariantChange(event) {
    const variant = event?.data?.variant;
    const sectionId = event?.data?.sectionId;
    const wrapper = findBackInStockWrapper(sectionId);

    if (!wrapper) return;

    const backInStockEl = wrapper.querySelector('[data-back-in-stock]');

    // The section HTML that came with the event already has the correct
    // visibility applied by Liquid (sold out, or out of stock and available for preorder)
    const nextWrapper = event?.data?.html?.querySelector('[id^="BackInStock-"]');
    const hide = nextWrapper
      ? nextWrapper.classList.contains('hidden')
      : !variant || variant.available;

    if (hide) {
      wrapper.classList.add('hidden');
    } else {
      wrapper.classList.remove('hidden');

      if (backInStockEl) {
        const variantIdInput = backInStockEl.querySelector('[data-variant-id]');
        const variantTitleInput = backInStockEl.querySelector('[data-variant-title]');
        const variantSkuInput = backInStockEl.querySelector('[data-variant-sku]');

        if (variantIdInput) variantIdInput.value = variant.id;
        if (variantTitleInput) variantTitleInput.value = variant.title === 'Default Title' ? '' : variant.title;
        if (variantSkuInput) variantSkuInput.value = variant.sku || '';

        // Title differs between sold out and preorder variants
        const title = backInStockEl.querySelector('[data-back-in-stock-title]');
        const nextTitle = nextWrapper?.querySelector('[data-back-in-stock-title]');
        if (title && nextTitle) title.textContent = nextTitle.textContent;

        // Reset form state when switching to a new sold-out variant
        const form = backInStockEl.querySelector('[data-back-in-stock-form]');
        const success = backInStockEl.querySelector('[data-success]');
        const message = backInStockEl.querySelector('[data-message]');
        if (form) form.style.display = '';
        if (success) success.style.display = 'none';
        if (message) message.style.display = 'none';
      }
    }
  }

  // Subscribe to the theme's pub/sub variant change event
  if (window.subscribe && window.theme?.PUB_SUB_EVENTS?.variantChange) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, handleVariantChange);
  }
})();
